import { FC } from 'react';
import Link from 'next/link';
import styles from './ListItem.module.scss';

interface IListItem {
  title: string;
  count: number;
  alias: string;
  itemAlias: string;
}

const ListItem: FC<IListItem> = ({ title, count, alias, itemAlias }) => {
  return (
    <li className={styles.listItem}>
      <Link prefetch={false} href={`/${alias}/${itemAlias}`} className={styles.listItem__name}>
        {title}
      </Link>
      <span className={styles.listItem__count}>
        <span className={styles.listItem__word}>{count}</span>
      </span>
    </li>
  );
};
export default ListItem;
